var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-section"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"hero-content"},[_c('h1',{staticClass:"hero-title"},[_c('span',{staticClass:"hero-title-line"},[_vm._v("山东省二级注册建造师")]),_c('span',{staticClass:"hero-title-line"},[_vm._v("继续教育平台")])])])])])
}]

export { render, staticRenderFns }